import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ArrowLeftIcon, HandshakeIcon, PhoneCallIcon, TargetIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const TeamLidJellePage: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-2304">
      <SEO title="Jelle Zwaanenburg, Sales Executive | Noord Digital" description="Maak kennis met Jelle Zwaanenburg, Sales Executive bij Noord Digital. Eerste aanspreekpunt voor groeivragen en passende voorstellen." canonical="https://noorddigital.nl/over-ons/jelle" data-id="element-2305" />
      <Header data-id="element-2306" />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-2307">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2308">
          <button onClick={() => navigate('/over-ons')} className="inline-flex items-center gap-2 text-[#004AC7] font-medium hover:underline mb-12" data-id="element-2309">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-2310" /> Terug naar het team
          </button>

          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-2311">
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-2312">
              <div className="w-[300px] h-[300px] rounded-full border-4 border-[#004AC7] overflow-hidden shadow-lg" data-id="element-2313">
                <img src="https://cdn.magicpatterns.com/uploads/5AvkpigfrYsv7QATg1Cgrc/WhatsApp_Image_2026-05-09_at_11.41.56.jpg" alt="Jelle Zwaanenburg" className="w-full h-full object-cover" style={{
                objectPosition: 'center 35%'
              }} data-id="element-2314" />
              </div>
            </div>

            <div className="lg:w-2/3" data-id="element-2315">
              <h1 className="text-4xl md:text-5xl font-bold text-[#111827] mb-2" data-id="element-2316">
                Jelle Zwaanenburg
              </h1>
              <p className="text-xl text-[#607697] font-medium mb-8" data-id="element-2317">
                Sales Executive
              </p>

              <div className="prose prose-lg text-[#4B5563] mb-12" data-id="element-2318">
                <p className="mb-4" data-id="element-2319">
                  Als Sales Executive bij Noord Digital ben ik vaak het eerste
                  gezicht waar je mee praat. Ik draai de sales en zorg dat jouw
                  vraag goed begrepen wordt voordat we een voorstel doen.
                </p>
                <p className="mb-4" data-id="element-2320">
                  Ik geloof niet in pushen of gladde verkooppraatjes. Een goed
                  gesprek begint met luisteren: wat speelt er bij jouw bedrijf,
                  waar wil je naartoe en wat is realistisch op korte termijn?
                  Pas daarna kijken we samen of Noord Digital de juiste partner
                  is.
                </p>
                <p data-id="element-2321">
                  Mijn rol is om de brug te slaan tussen jouw groeivraag en het
                  team dat het werk uitvoert. Helder, eerlijk en met een
                  voorstel waar je écht iets aan hebt.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-[#111827] mb-6" data-id="element-2322">
                Expertise
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2323">
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2324">
                  <PhoneCallIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2325" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2326">Sales</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2327">
                  <HandshakeIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2328" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2329">Klantcontact</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2330">
                  <TargetIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2331" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2332">
                    Voorstellen op maat
                  </h3>
                </div>
              </div>

              <a href="/#contact" className="inline-block bg-[#004AC7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-2333">
                Neem contact op met Jelle
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2334" />
    </div>;
};